<template>
  <div class="worth-container">
    <img src="https://ysh-cdn.kaidicloud.com/app/h5/app_download_introduce_1.png" />
    <img src="https://ysh-cdn.kaidicloud.com/app/h5/app_download_introduce_2.png" />
    <img src="https://ysh-cdn.kaidicloud.com/app/h5/app_download_introduce_3.png" />

    <div class="botttom-button">
      <img class="btn" id="download" @click="sendClickEvent()"
        src="https://ysh-cdn.kaidicloud.com/app/h5/ic_download_btn.png" />
      <img class="btn-bg" src="https://ysh-cdn.kaidicloud.com/app/h5/ic_download_btn_bg.png" />
    </div>
  </div>
</template>

<script>
import SlsTracker from '@aliyun-sls/web-track-browser'
export default {
  data() {
    return {
      downloadUrl: '',
      query: '',
      appQuery: '',
      code: '',
      slsOpts: {
        host: process.env.VUE_APP_BUILD_ENV == "pro" ? "cn-shanghai.log.aliyuncs.com" : "cn-shenzhen.log.aliyuncs.com", // 所在地域的服务入口。例如cn-hangzhou.log.aliyuncs.com
        project: process.env.VUE_APP_BUILD_ENV == "pro" ? "global-event-log-prod" : "global-event-log-test", // Project名称。
        logstore: process.env.VUE_APP_BUILD_ENV == "pro" ? "global-event-all-log" : "global-event-all-log", // Logstore名称。
        time: 10, // 发送日志的时间间隔，默认是10秒。
        count: 10, // 发送日志的数量大小，默认是10条。
      },
      apdId:''
    }
  },
  created() { },
  mounted() {
    const self = this;
    let { path = '', ...res } = this.$route.query || {}
    //console.log(this.$route.query.code)
    //对接ulink
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://g.alicdn.com/jssdk/u-link/index.min.js";
    document.getElementsByTagName("head")[0].appendChild(script);
    //等待挂载完成
    script.onload = function () {
      const ULink = window.ULink
      const url = (window.location.href || '').split('?')[1]
      const data = ULink.getUriParams(url)
      const ULinkId = process.env.VUE_APP_BUILD_ENV == "pro" ? "usr1024q50oaq65l" : "usr157alcp6tdv5v"
      console.log(process.env.VUE_APP_BUILD_ENV)
      self.apdId=data.apdId;
      ULink([{
        id: ULinkId,
        data: {
          apdId: data.apdId || ""
        },
        selector: "#download",
      }])
      self.sendPageEvent();
    }

    for (const [key, value] of Object.entries(res)) {
      this.query = key + '=' + value + '&' + this.query
    }

    if (this.query) {
      this.appQuery = path + '?' + this.query.substring(0, this.query.lastIndexOf('&'))
    } else {
      this.appQuery = path
    }

    // if (this.isEvn() == 'Android') {
    //   this.appQuery = 'yshapp://ysh:8888/' + this.appQuery
    // }

    //  IOS  + this.appQuery
    // else {
    //   this.appQuery = 'h.kaidicloud.com/' + this.appQuery
    // }

    //this.fetchData()
  },
  methods: {
    sendClickEvent() {
      console.log('sendClickEvent....')
      const tracker = new SlsTracker(this.slsOpts)
      tracker.send({
        platform: 'web',
        app_name: 'ysh',
        time: Date.parse(new Date()),
        date: this.getDate(),
        event: 'Click',
        apdId: this.apdId
      })
    },
    sendPageEvent() {
      console.log('sendPageEvent....')
      const tracker = new SlsTracker(this.slsOpts)
      tracker.send({
        platform: 'web',
        app_name: 'ysh',
        time: Date.parse(new Date()),
        date: this.getDate(),
        event: 'EnterPage',
        apdId: this.apdId
      })
    },
    getDate() {
      let now = new Date(),
        y = now.getFullYear(),
        m = now.getMonth() + 1,
        d = now.getDate();
      return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d);
    }
  },
}
</script>

<style lang="less" scoped>
.worth-container {
  display: flex;
  flex-direction: column;
}

.worth-container img {
  width: 100vw;
  height: auto;
}

.botttom-button {
  width: 100vw;
  height: 150px;
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 0;
}

.botttom-button .btn {
  position: absolute;
  left: 50%;
  top: 8px;
  transform: translate(-50%);
  width: 502px;
  height: 118px;
}

.botttom-button .btn-bg {
  width: 100%;
  height: 150px;
}
</style>
